var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather',{staticClass:"text-blue cursor-pointer",attrs:{"size":"16","type":_vm.orderBy.order.toLowerCase() == 'asc' ? 'arrow-up' : 'arrow-down'},on:{"click":function($event){return _vm.$emit('setOrderBy', _vm.column)}}})}
var staticRenderFns = []

export { render, staticRenderFns }